import { useParams } from "react-router-dom"
import { EvidenceScreen } from "../../screen/Evidences"
import { useForm } from "react-hook-form"
import { useEffect, useState } from "react"
import Send from "../../core/communication"
import moment from "moment"
import { useSelector } from "react-redux"
import {sort} from 'fast-sort'

/*
"analyticsDetails": {
      "section": "20211212",
      "date": "22/05/2021"
    },
    "user": {
      "id": "b0b5a5b4-9f9a-4b56-9e65-b980c4743203",
      "name": "Everton Bernardes",
      "email": "conext18@gmail.com"
    },
    "device": {
      "category": "mobile",
      "brand:": "null",
      "model": "Android SDK built for x86",
      "operating system": "Android 10",
      "language": "pt-br"
    },
    "location": {
      "continent": "America",
      "country": "Brasil",
      "region": "State of Santa Catarina",
      "city": "Biguaçu",
      "subcontinent": "South America"
    },
    "app": {
      "id": "com.manejebem.app",
      "version": "0.21.2"
    },
*/

const getTableDetails = (details) => {
  if (!details) {
    return []
  }
  const dataDetails = {
    analyticsDetails: {
      section: details.user_pseudo_id,
      date: moment(details.date, "YYYYMMDD").format("DD/MM/YYYY"),
      post: <a href={details.Link}>{details.Link}</a>,
    },
    user: {
      cpf: details.Documento,
      name: details.Nome_Completo,
    },
    location: {
      region: details.Estado,
      city: details.Cidade,
    },
    tec: {
      id: details.userId,
      name: details.Tecnico,
    },
    device: {
      category: details.device?.category,
      "brand:": details.device?.mobile_brand_name,
      model: details.device?.mobile_marketing_name,
      "operating system": details.device?.operating_system,
      language: details.device?.language,
    },
    app: {
      id: details.app_info?.id,
      version: details.app_info?.version,
    },
  }
  return [
    {
      title: "Evidências",
      value: "analyticsDetails",
      lineCaptions: ["Sessão do google analytics", "Data do evento", "Conteúdo"],
      data: dataDetails,
    },
    {
      title: "Produtor",
      value: "user",
      lineCaptions: ["ID AMBEV", "Nome do usuário"],
      data: dataDetails
    },
    {
      title: "Localização",
      value: "location",
      lineCaptions: ["Estado", "Cidade"],
      data: dataDetails,
    },
    {
      title: "Técnico",
      value: "tec",
      lineCaptions: ["ID do usuário", "ID AMBEV", "Nome do usuário"],
      data: dataDetails
    },
    {
      title: "Dispositivo",
      value: "device",
      lineCaptions: [
        "Categoria",
        "Marca do dispositivo",
        "Modelo do dispositivo",
        "Sistema operacional",
        "Idioma",
      ],
      data: dataDetails,
    },
    {
      title: "Aplicativo",
      value: "app",
      lineCaptions: ["ID", "Versão"],
      data: dataDetails,
    },
  ]
}

const EvidencesContainer = () => {
  const rehydrated = useSelector(state => state.app.rehydrated)
  const [contentType, setContentType] = useState("")
  const searchParams = useParams()
  const [options, setOptions] = useState([])
  const [details, setDetails] = useState()
  // const tableDetails = GetTableDetails()
  const [data, setData] = useState({
    posts: [],
  })

  useEffect(() => {
    if (rehydrated && searchParams && searchParams.userId) {
      Send.get("/bigquery/evidence", `userId=${searchParams.userId}`).then(({ posts, details }) => {
        posts = Array.isArray(posts) && posts.map(post => {
          const newPostEvidence = (details || []).find((item) => (
            item.muralId === post.PostId &&
            moment(item?.date, 'YYYYMMDD').format("YYYY") == moment(post.Inicio?.value).format("YYYY")
          ));

          return { ...post, evidenceDetail: newPostEvidence };
        })
        
        posts = sort(posts).asc([
          u => moment(u.Inicio?.value).toDate().getTime(),
          u => (details || []).find(item => item.muralId === u.PostId) ? 0 : 1
        ])

        console.log({posts, details})

        setData((data) => ({ ...data, posts, details }))
        setOptions(
          [...new Set(posts.map((item) => item.Trilha))].map((Trilha) => ({
            value: Trilha,
            label: Trilha,
          })),
        )
      })
    }
  }, [rehydrated])

  const { control } = useForm({
    mode: "onBlur",
  })

  const onChange = (value) => {
    setContentType(value)
  }

  if(!data){
    return <div>Não há nada por aqui!</div>
  }

  return (
    <EvidenceScreen
      evidenceData={data}
      tableDetails={getTableDetails(details)}
      sidebarOptions={options}
      control={control}
      onChange={(value) => onChange(value)}
      contentType={contentType}
      setDetails={setDetails}
    />
  )
}

export default EvidencesContainer
